import { LABOR_TICKET_ACTIONS } from 'lib/constants';

/** @readonly */
export const OPERATOR_AUTH_BUSY = {
  VERIFYING_PIN: 'verifyingPin',
  SIGNING_IN: 'signingIn',
  SIGNING_OUT: 'signingOut',
};

export function resolveSignInBusyPhase({ isSubmitting, showPinVerification }) {
  if (showPinVerification) return OPERATOR_AUTH_BUSY.VERIFYING_PIN;
  if (isSubmitting) return OPERATOR_AUTH_BUSY.SIGNING_IN;
  return null;
}

export function resolveGlobalAuthBusyPhase({
  isLoggingIn,
  isLoggingOut,
  laborTicketActionLoading,
  laborTicketAction,
}) {
  if (isLoggingOut) return OPERATOR_AUTH_BUSY.SIGNING_OUT;
  if (isLoggingIn) return OPERATOR_AUTH_BUSY.SIGNING_IN;
  if (
    laborTicketActionLoading &&
    (laborTicketAction === LABOR_TICKET_ACTIONS.OPERATOR_LOGOUT ||
      laborTicketAction ===
        LABOR_TICKET_ACTIONS.STOP_AND_CREATE_OPERATOR_LOGOUT)
  ) {
    return OPERATOR_AUTH_BUSY.SIGNING_OUT;
  }
  return null;
}
